import { InstitutionSettingsFragment } from '@/graphql/custom-types';
import { IInstitutionSettings, IProfile } from '@/interfaces';

export interface ILockedUser {
  id?: string;
  pinLocked: boolean;
  pinAttempts?: number;
  timestamp?: number;
  duration: number;
}

function getLockedUsers() {
  const lockedUsers = localStorage.getItem('lockedUsers');

  if (!lockedUsers) {
    return [];
  }

  return JSON.parse(lockedUsers) || [];
}

export async function attemptFailed(
  userId: string,
  institutionSettings: InstitutionSettingsFragment
) {
  const lockedUsers = getLockedUsers();
  const user = lockedUsers.find(
    (lockedUser: IProfile) => lockedUser.id === userId
  );

  const lockOutDuration =
    institutionSettings?.screen?.passwordProtection?.userLockedOutInMinutes ||
    0;

  const maxFailedAttempts =
    institutionSettings?.screen?.passwordProtection?.maxFailed || 3;

  const timestamp = Date.now() + lockOutDuration * 60 * 1000;

  if (user) {
    user.pinAttempts = user.pinAttempts + 1;
    user.pinLocked = user.pinAttempts >= maxFailedAttempts;
    user.timestamp = timestamp;
  } else {
    lockedUsers.push({
      id: userId,
      pinLocked: false,
      pinAttempts: 1,
      timestamp,
    });
  }

  localStorage.setItem('lockedUsers', JSON.stringify(lockedUsers));
}

export async function cleanLockedUsers() {
  let lockedUsers = getLockedUsers();

  lockedUsers = lockedUsers.filter((user: ILockedUser) => {
    const newDate = Math.floor(new Date(Date.now()).getTime());
    return newDate < (user?.timestamp || 0);
  });

  localStorage.setItem('lockedUsers', JSON.stringify(lockedUsers));
}

export function lockInfoByUserId(userId: string) {
  const lockedUsers = getLockedUsers();
  const user = lockedUsers.find(
    (lockedUser: ILockedUser) => lockedUser.id === userId
  );

  if (!user) {
    return {
      id: '',
      pinLocked: false,
      pinAttempts: 0,
      timestamp: 0,
      duration: -1,
    };
  }

  const newDate = Math.floor(new Date(Date.now()).getTime() / 1000);
  const userDate = Math.floor(user.timestamp / 1000);

  return {
    pinLocked: user?.pinLocked || false,
    duration: userDate - newDate,
  };
}
